import { fromEvent, from, of, EMPTY, interval } from 'rxjs';
import * as Rx from 'rxjs'
import { filter, map, mergeMap, scan, merge, withLatestFrom, groupBy, debounceTime, skip, skipUntil,
  startWith, tap, delay, combineLatest, switchMap, distinctUntilChanged, take, share } from 'rxjs/operators';
import _ from 'lodash'
// import { gql } from 'apollo-boost';
import { Dispatch } from 'architecture'

import { stateRefreshStream } from './functions'

//const scrollDistance$ = fromEvent(document, 'scroll')

//const resize$ = fromEvent(document, 'change').pipe().subscribe(e=>console.log(window.scrollTo(0, document.body.scrollHeight, {behavior: 'smooth'})))

Rx.merge(
    Dispatch.getAction('Instance', 'created'),
    //Dispatch.getState('States').pipe(take(1)),
    Dispatch.getState('Search')
      .pipe(
        switchMap(e => 
          // interval(100)
          // .pipe(
          //   filter(e => !_.isNil(document.getElementById("scrollToFooter"))),
          //   take(1)
          // )
          
          stateRefreshStream()
          .pipe(
            filter(e => e === false),
          )
        )
      )
    
  )
  .pipe(delay(200))
  .subscribe(e=>document.getElementById("scrollToFooter") && document.getElementById("scrollToFooter").scrollIntoView())
  //.subscribe(e=>window.scrollTo(0, document.body.scrollHeight, {behavior: 'smooth'}))

const bob$ = fromEvent(document, 'drop').subscribe(e => console.log(e))

// const dragOver$ = fromEvent(document, 'dragover')
//   .pipe(
//     filter(e => e.target.id && e),
//     // tap(e => console.log("wtf")),
//     // tap(e => console.log(e)),
//     map(e => ({
//       target: e.target.id,
//       inputType: containsFiles(e) ? 'file' : 'somethingelse',
//       id: e.target.id && e.target.id.split('-')[0],
//       type: e.target.id && e.target.id.split('-')[1],
//     })),
//     distinctUntilChanged((prev, next) => _.isEqual(prev,next)),
//     debounceTime(100)
//   )
//   .subscribe(e => Dispatch.nextState('dragTarget', e))

fromEvent(document, 'dragover')
  .pipe(
    // tap(e => console.log("wtf")),
    // tap(e => console.log(e)),
    filter(e => containsFiles(e)),
    map(e => true),
    // map(e => ({
    //   target: e.target.id,
    //   inputType: containsFiles(e) ? 'file' : 'somethingelse',
    //   id: e.target.id && e.target.id.split('-')[0],
    //   type: e.target.id && e.target.id.split('-')[1],
    // })),
    // distinctUntilChanged((prev, next) => _.isEqual(prev,next)),
    // debounceTime(100)
  )
  .subscribe(e => Dispatch.nextState('dragging', true))

// fromEvent(document, 'mouseup')
//   .pipe(
//   )
//   .subscribe(e => Dispatch.nextState('dragTarget', {}))

// fromEvent(document, 'scroll')
// .subscribe(e => console.log(e))

fromEvent(document, 'mouseup')
.pipe(
)
.subscribe(e => Dispatch.nextState('dragging', false))

  function containsFiles(event) {

    if (event.dataTransfer.types) {
        for (var i = 0; i < event.dataTransfer.types.length; i++) {
            if (event.dataTransfer.types[i] == "Files") {
                return true;
            }
        }
    }
    
    return false;

}

Dispatch.getAction('navigate', 'chat')
  .pipe(
    
  )
  .subscribe(e => Dispatch.nextState('view', 'chat'))

  Dispatch.getAction('Sidebar', 'change')
  .pipe(
    withLatestFrom(Dispatch.getState('Sidebar.open')),
    map(([action, state]) => !state),
    startWith(true)
  )
  .subscribe(e => Dispatch.mergeState('Sidebar', { open: e }))

  Dispatch.getAction('TagEditor', 'change')
  .pipe(
    withLatestFrom(Dispatch.getState('Sidebar.TagEditor.open')),
    map(([action, state]) => !state),
    startWith(false)
  )
  .subscribe(e => Dispatch.mergeState('Sidebar.TagEditor', { open: e }))

  Dispatch.getAction('TagEditor', 'open')
  .pipe(
  )
  .subscribe(e => Dispatch.mergeState('Sidebar.TagEditor', { open: true }))

  Dispatch.getAction('TagEditor', 'close')
  .pipe(
  )
  .subscribe(e => Dispatch.mergeState('Sidebar.TagEditor', { open: false }))

  const size$ = fromEvent(window, 'resize')
  .pipe(
    map(e => ({ height: e.target.innerHeight, width: e.target.innerWidth})),
    startWith({ height: window.innerHeight, width: window.innerWidth})
  )
  .subscribe(e => Dispatch.mergeState('Window', e))


  //Possibly get scrollHeight of the element and then compare to new scroll height (on load) and then scroll to (newScrollHeight - oldScrollHeight) 
//Start of scroll for loading more items
// Doesn't reset count on search
Dispatch.getState('LoadCount')
  .pipe(
    combineLatest(Dispatch.getState('RawStates')
      .pipe(
        filter(state => state !== null)
      )
    ),
    filter(([count, states]) => count - 40 <= states.length),
      switchMap(e => of(1)//interval(500)
        .pipe(
          delay(5),
          //takeUntil(e => !_.isNil(document.querySelector('#stream')),
          //filter(e => !_.isNil(document.querySelector('#stream'))),
          map(e => document.querySelector('#stream')),
          mergeMap(f => 
            fromEvent(f, 'scroll')
            .pipe(
              scan((acc,next) => acc ? true : f.scrollTop > 1000 ? true : false, false),
              filter(e => e && f.scrollTop < 1000),
              map(value => f.scrollTop),
              take(1),
            )
          )
      ),
    ),
    scan((acc, next) => { return acc+40 }, 70),
    startWith(70)
  )
  .subscribe(e => Dispatch.nextState('LoadCount', e))


const rawStateRefreshing$ = () => {
  const nulledRaw$ = Dispatch.getState('RawStates')
    .pipe(
      filter(e => e === null),
      take(1),
      map(e => true)
    )
  const nulledRaw2$ = Dispatch.getState('RawStates')
    .pipe(
      skipUntil(nulledRaw$),
      filter(e => e !== null),
      take(1),
      map(e => false)
    )
  return Rx.merge(nulledRaw$, nulledRaw2$)
}

Dispatch.getState('LoadCount')
  .pipe(
    switchMap(e => rawStateRefreshing$())
  )
  .subscribe(e => Dispatch.mergeState('ui', { loadingMore: e }))

  // Full reloading true/false
  Dispatch.getState('Search')
    .pipe(
      switchMap(e => rawStateRefreshing$())
    )
    .subscribe(e => Dispatch.mergeState('ui', { loadingAll: e }))
// fromEvent('document', focus)
// // Listen to all inputs and check for "TagInput" class
// Dispatch.getAction('LatestInput')
//   .pipe(

//   )
//   .subscribe(e => Dispatch.nextState('LatestInput', e))

Dispatch.getAction('UI', 'viewAs')
    .pipe(

      startWith({ value: 'stream', label: 'Stream' })
    )
    .subscribe(e => Dispatch.mergeState('ui', { viewAs: e }))